export const BASE_PATIENT_PATH = '/patients';

export const INDEX_PATIENTS_PATH = `${ BASE_PATIENT_PATH }`;
export const NEW_PATIENT_PATH = `${ BASE_PATIENT_PATH }/new`;
export const SHOW_PATIENT_PATH = `${ BASE_PATIENT_PATH }/show/:id`;
